import { formatApiPrice, formatLocation, useRouter } from '@application/utils';
import type { BreederListGetLittersQuery } from '@gql/graphql';
import type { CardItemLitterData } from '@presentation/components';
import { PLACEHOLDER_IMAGE_DOG } from '@presentation/constants';
import dayjs from 'dayjs';
import { useCallback } from 'react';

export const useFormatLitter = () => {
  const { routeLocationDescriptor, translate, language, infoFromCurrentPath } = useRouter();

  const formatLitter = useCallback(
    (litter: NonNullable<NonNullable<BreederListGetLittersQuery['findManyLitter']>>[number]) => {
      let breed = `${litter.dogBreed?.translations[0]?.name ?? ''} ${translate(
        'glossary.puppies',
      )}`;
      if (language === 'fr') {
        breed = `${translate('glossary.puppies')} ${litter.dogBreed?.translations[0]?.name ?? ''}`;
      }
      return {
        id: litter.id,
        breed,
        image: litter.imgs?.[0]?.small ?? PLACEHOLDER_IMAGE_DOG,
        price: formatApiPrice({ ...litter }),
        hasPedigreeFciBadge: litter.pedigree === 'FCI',
        hasPedigreeBadge: !(
          !litter.pedigree ||
          litter.pedigree === 'no_pedigree' ||
          litter.pedigree === 'FCI'
        ),
        location: formatLocation(
          {
            country: litter.breeder.account?.address?.country,
            region: litter.breeder.account?.address?.region,
          },
          translate,
        ),
        ...(!litter.born
          ? {
              futureLitter: {
                month: dayjs(litter.birthday)?.format?.('MMMM') ?? '-',
                year: dayjs(litter.birthday)?.format?.('YYYY') ?? '-',
              },
            }
          : {}),
        link: routeLocationDescriptor('litter', {
          params: [litter.translations?.[0]?.url ?? ''],
          state: {
            returnSearch: infoFromCurrentPath?.search,
          },
        }),
      } as CardItemLitterData;
    },
    [infoFromCurrentPath?.search, language, routeLocationDescriptor, translate],
  );

  return { formatLitter };
};
